import React, { useState } from 'react';
import '../../../stylesheets/productFaq.scss';
import IRSTaxModal from '../TaxProducts/IRSTaxModal';

export const ProductFaq = (props) => {
  const [efileModal, setEfileModal] = useState(false);
  const openEfileModal = () => {
    setEfileModal(true);
  };
  const closeEfileModal = () => {
    setEfileModal(false);
  };
  return (
    <div className="product-faq-container">
      <div className="footer-main-section">
        <div className="container-center-lg">
          <div className="footer-section">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h2 style={{ textAlign: 'center' }}>{props.FaqDescription.Header}</h2>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div className="faq-desp-left">
                  {props.FaqDescription.LeftQuestionList.map((listItem, index) => {
                    return (
                      <div id={index} className="faq-descp-container">
                        <div className="faq-des-header">{listItem.Header}</div>
                        <div className="faq-des-content">{listItem.Description}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                {props.FaqDescription.RightQuestionList.map((listItem, index) => {
                  return (
                    <div id={index} className="faq-descp-container">
                      <div className="faq-des-header">{listItem.Header}</div>
                      <span className="faq-des-content">{listItem.Description}</span>
                      {listItem.LearnMore && (
                        <span
                          onClick={openEfileModal}
                          className="faq-des-content"
                          style={{ cursor: 'pointer' }}
                        >
                          {listItem.LearnMore}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      {props.HasEfileModal && (
        <IRSTaxModal open={efileModal} close={closeEfileModal} openModal={openEfileModal} />
      )}
    </div>
  );
};
